var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,9.8c-2.1-1.1-4.3-2.2-6.4-3.3c-0.9-1.7-1.9-3.4-2.9-5.2c-0.2-0.3-0.3-0.7-0.5-1.1C9.9-0.2,9.7,0.1,9.6,0.4 C9.1,1.3,8.6,2.2,8.2,3.1l0,0l0,0C7.7,4.2,7.2,5.2,6.7,6.3C6.2,6.5,5.8,6.8,5.4,7C4.6,7.3,3.9,7.7,3.2,8C2.2,8.6,1,9.1,0,9.8 c-0.1,0.2,0.2,0.2,0.3,0.3c0.4,0.3,0.8,0.5,1.2,0.7c1.6,1.1,3.4,1.8,5.2,2.8c0.4,0.4,0.5,1,0.8,1.4c0.5,1,1.1,2.1,1.6,3 c0.2,0.5,0.5,1,0.8,1.5c0.1,0.1,0.1,0.4,0.3,0.3c-0.1,0.1,0.2,0.2,0.2,0l0,0c0.3-0.6,0.7-1.2,1.1-1.8c0.8-1.6,1.7-3.1,2.3-4.8 c0.9-0.4,1.6-1,2.4-1.4c1.2-0.7,2.5-1.3,3.8-1.9C20,10,20,9.8,20,9.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2088d556a7c109a415968f32a2291555.svg";
export { ForwardRef as ReactComponent };